import { CloseOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import React from 'react';
import './style.scss';
function ModalComponent({ visible, setVisible, children, width, afterClose }) {
  return (
    <>
      <Modal
        afterClose={() => {
          if (afterClose) {
            afterClose();
          }
        }}
        centered
        footer={null}
        visible={visible}
        width={width}
        onCancel={() => {
          setVisible(!visible);
        }}
      >
        {children}
        <CloseOutlined
          onClick={() => {
            setVisible(!visible);
          }}
        />
      </Modal>
    </>
  );
}

ModalComponent.propTypes = {};

export default ModalComponent;
